import { createGlobalStyle } from "styled-components";

import AvenirMedium from "./assets/fonts/AvenirNext-Medium.ttf";
import AvenirRegular from "./assets/fonts/AvenirNext-Regular.ttf";
import CormorantSemibold from "./assets/fonts/CormorantInfant-Semibold.otf"

type GlobalStyleProps = {
  $bodyBackground?: string;
};

export const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  @font-face {
    font-family: 'Avenir Next';
    src: url(${AvenirRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Avenir Next';
    src: url(${AvenirMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
    }
  
  @font-face {
    font-family: 'Cormorant Infant';
    src: url(${CormorantSemibold}) format('opentype');
    font-weight: 600;
    font-style: normal;
  }

  *, *::before, *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }

  body {
    margin: 0;
    padding: 0;
    background-color: ${({ $bodyBackground }) => $bodyBackground || "rgb(249,249,249)"};
    font-family: "Avenir Next", sans-serif;
    color: #141414;
    letter-spacing: -0.04em;
    &::-webkit-scrollbar {
    width: 0 !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; 
    }
  }

  button {
    all: unset;
    font-size: inherit;
    cursor: pointer;
  }

  ul, li {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  
  h1, h2, h4, h4 {
    letter-spacing: -0.04em;
  }
`;
